import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelopeOpen, FaTwitter, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { useLocation } from "react-router-dom";
const Herohead = React.lazy(() => import('./Herohead'))
const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation(); // Get the current location object
    const currentPath = location.pathname; // Extract the current path
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleNavbar = () => {
        setIsCollapsed(!isCollapsed);

    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true); // User scrolled past 50px
            } else {
                setScrolled(false); // User is at the top
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <nav role="navigation">
                <div className="container-fluid bg-[#fefefec5]  px-4 py-1 d-none d-lg-block ">
                    <div className="max-lg:px-2 px-6 row gx-0">
                        <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
                            <div className="inline-flex items-center h-[45px]">
                                <small className="me-3  lg:text-[12px] xl:text-[14px] text-dark flex justify-center items-center cursor-pointer"><FaMapMarkerAlt className="mr-2" />Wb-82 Shakarpur,Laxmi Nagar,New
                                    Delhi</small>
                                <small className="lg:text-[12px] xl:text-[14px]"> <a href="tel:9560070953" className="no-underline cursor-pointer me-3 text-dark flex justify-center items-center"><FaPhoneAlt className="mr-2" />+91 9560070953</a></small>
                                <small className="text-dark flex justify-center items-center lg:text-[12px] xl:text-[14px]"><a href="mailto:shriradheholidayss@gmail.com?subject=Inquiry&body=Hello, I would like to know more about your services." className="no-underline cursor-pointer me-3 text-dark flex justify-center items-center"> <FaEnvelopeOpen className="mr-2" />shriradheholidayss@gmail.com</a></small>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <div className="inline-flex items-center  h-[45px]">
                                <a
                                    className="flex items-center justify-center mx-1 w-9 h-9 rounded-full border e text-white transition duration-300 bg-[#1DA1F2] border-[#1DA1F2]"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://x.com/ShRadheHolidays"
                                    aria-label="Follow us on Twitter"
                                >
                                    <FaTwitter className="text-lg " />
                                </a>
                                <a
                                    className="flex items-center justify-center mx-1 w-9 h-9 rounded-full border  text-white transition duration-300 bg-[#1877F2] border-[#1877F2]"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.facebook.com/profile.php?id=61573011625834"
                                    aria-label="Like us on Facebook"
                                >
                                    <FaFacebookF className="text-lg" />
                                </a>
                                <a
                                    className="flex items-center justify-center mx-1 w-9 h-9 rounded-full border  text-white transition duration-300 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.instagram.com/shriradheholidays/"
                                    aria-label="Follow us on Instagram"
                                >
                                    <FaInstagram className="text-lg" />
                                </a>
                                <a
                                    className="flex items-center justify-center mx-1 w-9 h-9 rounded-full border  text-white transition duration-300 bg-[#FF0000] border-[#FF0000]"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.youtube.com/@ShriRadheHolidays"
                                    aria-label="Subscribe to our YouTube channel"
                                >
                                    <FaYoutube className="text-lg" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid position-relative p-0">
                    <nav className={`!z-20 nav lg:bg-transparent navbar-expand-lg navbar-light px-[7px]  flex items-center justify-center ${scrolled ? "sticky-top shadow-sm" : ""
                        }`} style={{ justifyContent: "space-between" }} >
                        <a href="/" className="xl:ml-[30px] ml:0 flex w-1/2 lg:w-[34.5%] navbar-brand">
                            <img
                                src="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/logo2_lp2aee"
                                loading="lazy"
                                width={100}
                                height={100}
                                alt="Shri Radhe Holidays"
                                title="Shri Radhe Holidays"
                                className="object-contain mt-3"
                            />
                        </a>

                        {/* <h1 className={`${scrolled ? "text-black" : "text-white"}  mt-[22px] text-3xl dancing-script-font ml-2`}>Shri Radhe Holidays</h1> */}
                        <button className={`navbar-toggler collapsed lg:hidden xl:hidden 2xl:hidden`} type="button" aria-label="toogleBar" aria-labelledby="togglebutton" >
                            {/* <FaBars className={`text-black text-4xl`} /> */}
                            <label className="hamburger ">
                                <input onClick={toggleNavbar} type="checkbox" className={`navbar-toggler collapsed lg:hidden xl:hidden 2xl:hidden`} />
                                <svg viewBox="0 0 32 32">
                                    <path className="line" d="M7 16 27 16"></path>
                                    <path className="line line-top-bottom" d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"></path>
                                </svg>
                            </label>
                        </button>
                        <div className={`mx-3 navbar-collapse collapse ${isCollapsed ? "show " : ""}`} id="navbarCollapse">
                            <div className={`${isCollapsed ? "flex flex-row items-center justify-between" : ""} navbar-nav ms-auto py-0`}>
                                <a
                                    href="/"
                                    className={`nav-item nav-link ${currentPath === "/" ? "active" : ""
                                        }`}
                                >Home</a>
                                <a
                                    href="/group-tour"
                                    className={`nav-item nav-link ${currentPath === "/group-tour" ? "active" : ""
                                        }`}
                                >Group Tours</a>
                                <a href="/services" className={`nav-item nav-link ${currentPath === "/services" ? "active" : ""
                                    }`}>Services</a>
                                <a href="/about" className={`nav-item nav-link ${currentPath === "/about" ? "active" : ""
                                    }`}>About</a>

                                <a href="/contact" className={` nav-item nav-link   ${currentPath === "/contact" ? "active" : ""
                                    }`}>Contact</a>
                            </div>
                            <button
                                type="submit"
                                onClick={() =>
                                    window.open(
                                        `https://wa.me/919560070953?text=${encodeURIComponent(
                                            "Hi, I want to plan a customized trip. Please share options with pricing and itinerary."
                                        )}`,
                                        "_blank"
                                    )
                                }
                                className={`mb-2 lg:text-[16px] xl:text-[18px]  ${isCollapsed ? "w-full rounded-r-full rounded-l-none" : ""}  text-[#0B1C3D] flex justify-center gap-2 items-center  shadow-xl text-lg bg-[#D4AF37] backdrop-blur-md lg:font-semibold isolation-auto   before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-[#0B1C3D] hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-4 py-2 overflow-hidden  rounded-full group`}
                            >
                                Customize Your Trip
                                <svg
                                    className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-50 text-[#0B1C3D] ease-linear duration-300 rounded-full border border-[#D4AF37] group-hover:border-none p-2 rotate-45"
                                    viewBox="0 0 16 19"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                        className="fill-[#0B1C3D] group-hover:fill-[#0B1C3D]"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </nav>
                    <Herohead />
                </div>
            </nav >
        </>
    );
};

export default Navbar;
